import Mutations from '../../odata/mutations';

export default { ...new Mutations('customerUser'), ...new Mutations('customerUsers') };
